export const getGroupSegmentLabel = (isSegment: boolean, count: number) => {
  if (isSegment) {
    return count === 1 ? 'Segment' : 'Segments'
  }
  return count === 1 ? 'Group' : 'Groups'
}
